'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp; /**
                                   * Created by lyj on 2016/5/18.
                                   */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reduxForm = require('redux-form');

var _GoeasyInputField = require('../GoeasyInputField/GoeasyInputField');

var _GoeasyInputField2 = _interopRequireDefault(_GoeasyInputField);

var _VerificationCodeInput = require('../GoeasyInputField/VerificationCodeInput');

var _VerificationCodeInput2 = _interopRequireDefault(_VerificationCodeInput);

var _SubmitBtn = require('../SubmitBtn/SubmitBtn');

var _SubmitBtn2 = _interopRequireDefault(_SubmitBtn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RegisterForm = (_dec = (0, _reduxForm.reduxForm)({
  form: 'register',
  fields: ['loginName', 'password', 'passwordAgain', 'nickName', 'mobile', 'verificationCode']
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(RegisterForm, _Component);

  function RegisterForm() {
    (0, _classCallCheck3.default)(this, RegisterForm);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(RegisterForm).call(this));

    _this.state = {
      verifyClick: false,
      waitingTime: 60
    };
    return _this;
  }

  (0, _createClass3.default)(RegisterForm, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearInterval(this.interval);
      clearTimeout(this.timeout);
    }
  }, {
    key: 'onVerifyClick',
    value: function onVerifyClick() {
      var _this2 = this;

      var _props = this.props;
      var mobile = _props.fields.mobile;
      var getVerifyCode = _props.getVerifyCode;

      if (getVerifyCode) {
        getVerifyCode(mobile.value);
        this.setState({
          verifyClick: true
        });
        this.interval = setInterval(function () {
          _this2.setState({
            waitingTime: _this2.state.waitingTime - 1
          });
        }, 1000);
        this.timeout = setTimeout(function () {
          clearInterval(_this2.interval);
          _this2.setState({
            verifyClick: false,
            waitingTime: 60
          });
        }, 60000);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var styles = require('./PersonalInfoChange.scss');
      var _props2 = this.props;
      var _props2$fields = _props2.fields;
      var loginName = _props2$fields.loginName;
      var password = _props2$fields.password;
      var passwordAgain = _props2$fields.passwordAgain;
      var nickName = _props2$fields.nickName;
      var mobile = _props2$fields.mobile;
      var verificationCode = _props2$fields.verificationCode;
      var handleSubmit = _props2.handleSubmit;
      var _state = this.state;
      var verifyClick = _state.verifyClick;
      var waitingTime = _state.waitingTime;

      return _react2.default.createElement(
        'form',
        { onSubmit: handleSubmit },
        _react2.default.createElement(
          'div',
          { className: styles.component + ' ' + styles.register },
          _react2.default.createElement(_GoeasyInputField2.default, { label: '登录名：', inputPlaceholder: '支持符号、英文、中文或符号/英文/中文/数字的组合，长度位4-20位', formProps: loginName }),
          _react2.default.createElement(_GoeasyInputField2.default, { label: '昵称：', inputPlaceholder: '', formProps: nickName }),
          _react2.default.createElement(_GoeasyInputField2.default, { label: '密码：', inputType: 'password', inputPlaceholder: '', formProps: password }),
          _react2.default.createElement(_GoeasyInputField2.default, { label: '再次输入密码：', inputType: 'password', inputPlaceholder: '', formProps: passwordAgain }),
          _react2.default.createElement(_GoeasyInputField2.default, { label: '手机：', disabled: verifyClick, inputPlaceholder: '', formProps: mobile,
            value: mobile.value }),
          _react2.default.createElement(_VerificationCodeInput2.default, { click: this.onVerifyClick.bind(this), formProps: verificationCode,
            waitingTime: waitingTime, clicked: verifyClick }),
          _react2.default.createElement(_SubmitBtn2.default, { btnClick: handleSubmit, text: '提交' })
        ),
        _react2.default.createElement('div', { className: 'clear' })
      );
    }
  }]);
  return RegisterForm;
}(_react.Component), _class2.propTypes = {
  active: _react.PropTypes.string,
  asyncValidating: _react.PropTypes.bool.isRequired,
  fields: _react.PropTypes.object.isRequired,
  dirty: _react.PropTypes.bool.isRequired,
  resetForm: _react.PropTypes.func.isRequired,
  invalid: _react.PropTypes.bool.isRequired,
  pristine: _react.PropTypes.bool.isRequired,
  valid: _react.PropTypes.bool.isRequired,
  handleSubmit: _react.PropTypes.func,
  getVerifyCode: _react.PropTypes.func
}, _temp)) || _class);
exports.default = RegisterForm;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/PersonalInfoChange/RegisterForm.js
 ** module id = 1402
 ** module chunks = 0
 **/